import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const Paragraph = ({ widths }) => (
  <SkeletonText lines={widths.length} widths={widths} lineHeight="20px" gap="0.6rem" />
);

const PublicArticleSkeleton = () => (
  <article
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-lg)',
      maxWidth: '720px',
      margin: '0 auto',
      padding: 'clamp(1.5rem, 4vw, 3rem) var(--space-xl) clamp(2rem, 5vw, 3rem)',
    }}
  >
    {/* Breadcrumb */}
    <div style={{ display: 'flex', gap: 'var(--space-sm)', alignItems: 'center' }}>
      <SkeletonText widths={['56px']} lineHeight="14px" />
      <SkeletonText widths={['8px']} lineHeight="14px" />
      <SkeletonText widths={['96px']} lineHeight="14px" />
    </div>

    {/* Title */}
    <SkeletonText widths={['min(620px, 90%)']} lineHeight="44px" />
    <SkeletonText widths={['min(540px, 80%)']} lineHeight="36px" />

    {/* Meta row */}
    <div style={{ display: 'flex', gap: 'var(--space-md)', alignItems: 'center' }}>
      <SkeletonCircle size={36} />
      <div style={{ display: 'flex', flexDirection: 'column', gap: '0.3rem' }}>
        <SkeletonText widths={['96px']} lineHeight="14px" />
        <SkeletonText widths={['140px']} lineHeight="12px" />
      </div>
    </div>

    {/* Featured image */}
    <SkeletonBox height={320} borderRadius="var(--radius-lg)" />

    {/* Body */}
    <Paragraph widths={['100%', '100%', '92%', '85%']} />
    <SkeletonText widths={['52%']} lineHeight="24px" />
    <Paragraph widths={['100%', '100%', '88%']} />
    <Paragraph widths={['100%', '92%', '70%']} />
    <SkeletonText widths={['44%']} lineHeight="24px" />
    <Paragraph widths={['100%', '100%', '94%', '60%']} />
  </article>
);

export default PublicArticleSkeleton;
